import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Box from '../../../../components/Box';
import CustomMultiSelect, { CustomMultiSelectModel } from '../../../../components/CustomMultiSelect';
import CustomSingleSelect, { CustomSingleSelectModel } from '../../../../components/CustomSingleSelect';
import { Helpers } from '../../../../helpers/Helpers';
import { storeFastFirm, storeImageViewer } from '../../../../redux/reducers/authSlice';
import { CompanyService } from '../../../../services/CompanyService';
import { ConstantService } from '../../../../services/ConstantService';
import { DriverService } from '../../../../services/DriverService';
import { VehicleService } from '../../../../services/VehicleService';
import { KTCard } from '../../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../../_metronic/helpers/components/KTCardBody';
import CustomTextInput from '../../../../components/CustomTextInput';
import CustomSwitch from '../../../../components/CustomSwitch';
import CustomNumberInput from '../../../../components/CustomNumberInput';
import { GetConstantListResponseItem } from '../../../../models/response/constant/GetConstantListResponse';

interface Props {
    generalInformationRef: any
    selectedVehicleStatus: CustomSingleSelectModel | undefined
    setSelectedVehicleStatus: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    plate: string
    setPlate: React.Dispatch<React.SetStateAction<string>>
    selectedFuelType: CustomSingleSelectModel | undefined
    selectedVehicleArea: CustomSingleSelectModel | undefined
    selectedVehicleArea2: CustomSingleSelectModel | undefined
    selectedVehicleType: CustomSingleSelectModel | undefined
    setSelectedVehicleType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedVehicleType2: CustomSingleSelectModel | undefined
    setSelectedVehicleType2: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedVehicleOwnerCompany: CustomSingleSelectModel | undefined
    setSelectedVehicleOwnerCompany: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedDriver: CustomSingleSelectModel | undefined
    setSelectedDriver: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    setSelectedFuelType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    setSelectedVehicleArea: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    setSelectedVehicleArea2: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    fuelConsumed: string | undefined
    setFuelConsumed: React.Dispatch<React.SetStateAction<string | undefined>>
    fuelCapacity: string | undefined
    setFuelCapacity: React.Dispatch<React.SetStateAction<string | undefined>>
    hgsEtiketNo: string | undefined
    setHgsEtiketNo: React.Dispatch<React.SetStateAction<string | undefined>>
    isBlocked: boolean
    blockedDesc: string | undefined
    setBlockedDesc: React.Dispatch<React.SetStateAction<string | undefined>>
    setIsBlocked: React.Dispatch<React.SetStateAction<boolean>>
    selectedVehicleProperties: CustomMultiSelectModel[]
    setSelectedVehicleProperties: React.Dispatch<React.SetStateAction<CustomMultiSelectModel[]>>
    b64: string
    setB64: React.Dispatch<React.SetStateAction<string>>
    isCustomActive: boolean
    setIsCustomActive: React.Dispatch<React.SetStateAction<boolean>>
    fileRef: any
    setFile: React.Dispatch<React.SetStateAction<File | undefined>>
    vehicleTypeList2: GetConstantListResponseItem[]
    handleFileRead: (event: any, setFunction: React.Dispatch<React.SetStateAction<string>>) => Promise<void>
    selectedTrailer: CustomSingleSelectModel | undefined
    setSelectedTrailer: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
}

const GeneralInformation = ({
    generalInformationRef,
    selectedVehicleStatus,
    setSelectedVehicleStatus,
    plate,
    setPlate,
    selectedFuelType,
    selectedVehicleArea,
    selectedVehicleArea2,
    selectedVehicleType,
    setSelectedVehicleType,
    selectedVehicleType2,
    setSelectedVehicleType2,
    selectedVehicleOwnerCompany,
    setSelectedVehicleOwnerCompany,
    selectedDriver,
    setSelectedDriver,
    setSelectedFuelType,
    setSelectedVehicleArea,
    setSelectedVehicleArea2,
    fuelConsumed,
    setFuelConsumed,
    fuelCapacity,
    hgsEtiketNo,
    setHgsEtiketNo,
    setFuelCapacity,
    isBlocked,
    blockedDesc,
    setBlockedDesc,
    setIsBlocked,
    b64,
    selectedVehicleProperties,
    setB64,
    setSelectedVehicleProperties,
    isCustomActive,
    setIsCustomActive,
    fileRef,
    setFile,
    vehicleTypeList2,
    handleFileRead,
    selectedTrailer,
    setSelectedTrailer,
}: Props) => {
    const dispatch = useDispatch();
    const [imageSearch, setImageSearch] = useState<string | undefined>(undefined);

    return (
        <div className='containerPart' ref={generalInformationRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                    <div className='row'>
                        <div className="col-md-9">
                            <div className="row">
                                <div className="col-md-6">
                                    <div>
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Araç Plakası</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={plate} onChange={(e) => setPlate(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Araç Durumu</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedVehicleStatus}
                                            onChange={setSelectedVehicleStatus}
                                            insertable={{
                                                onSubmit: { code: 'VEHICLE_STATUS' }
                                            }}
                                            onMenuOpen={() => ConstantService.getConstantList('VEHICLE_STATUS')}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>


                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Araç Cinsi</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedVehicleType}
                                            onChange={(selectedValue) => {
                                                if (selectedValue) {
                                                    if (!(selectedValue.additionalValue1 == "2" || selectedValue.additionalValue1 == "4"))
                                                        setSelectedTrailer(undefined);
                                                }
                                                else
                                                    setSelectedTrailer(undefined);

                                                setSelectedVehicleType(selectedValue);
                                            }}
                                            insertable={{
                                                onSubmit: { code: 'VEHICLE_TYPE' }
                                            }}
                                            onMenuOpen={() => ConstantService.getConstantList('VEHICLE_TYPE')}
                                            labelName='value'
                                            valueName='constantId'
                                            additionalValue1Name='additionalValue1'
                                        />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Araç Bölgesi</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedVehicleArea}
                                            onChange={setSelectedVehicleArea}
                                            insertable={{
                                                onSubmit: { code: 'VEHICLE_AREA' }
                                            }}
                                            onMenuOpen={() => ConstantService.getConstantList('VEHICLE_AREA')}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Araç Sahibi</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedVehicleOwnerCompany}
                                            onChange={setSelectedVehicleOwnerCompany}
                                            insertable={{
                                                tooltipText: 'Firma seçilmeden basıldığında Yeni firma tanımlaması yapılmasını, firma seçimi yapıldıktan sonra basıldığında ise seçilen firmanın bilgilerinin Güncellenmesini sağlar.',
                                                onClick: () => {
                                                    dispatch(storeFastFirm({
                                                        companyId: selectedVehicleOwnerCompany?.value,
                                                        isSupplier: true,
                                                        onSubmit: async (response) => {
                                                            setSelectedVehicleOwnerCompany({ label: response.name, value: response.companyId })
                                                        }
                                                    }))
                                                }
                                            }}
                                            onMenuOpen={() => CompanyService.getCompanyList({ isSupplier: true })}
                                            labelName='name'
                                            valueName='companyId'
                                        />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Sürücü</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedDriver}
                                            onChange={setSelectedDriver}
                                            onMenuOpen={() => DriverService.getDriverList()}
                                            labelName='nameSurname'
                                            valueName='driverId'
                                        />
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div>
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Dorse Plakası</label>

                                        <CustomSingleSelect
                                            disabled={selectedVehicleType && (selectedVehicleType?.additionalValue1 == "2" || selectedVehicleType?.additionalValue1 == "4") ? false : true}
                                            selectedValue={selectedTrailer}
                                            onChange={setSelectedTrailer}
                                            onMenuOpen={() => VehicleService.getVehicleList(["6", "7"])}
                                            labelName='plate'
                                            valueName='vehicleId'
                                        />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Yakıt Türü</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedFuelType}
                                            onChange={setSelectedFuelType}
                                            insertable={{
                                                onSubmit: { code: 'FUEL_TYPE' }
                                            }}
                                            onMenuOpen={() => ConstantService.getConstantList('FUEL_TYPE')}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Araç Cinsi 2</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedVehicleType2}
                                            onChange={setSelectedVehicleType2}
                                            insertable={{
                                                onSubmit: { code: 'VEHICLE_TYPE_2' }
                                            }}
                                            onMenuOpen={() => ConstantService.getConstantList('VEHICLE_TYPE_2')}
                                            labelName='value'
                                            valueName='constantId'
                                            additionalValue1Name='additionalValue1'
                                        />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Araç Alt Bölgesi</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedVehicleArea2}
                                            onChange={setSelectedVehicleArea2}
                                            insertable={{
                                                onSubmit: { code: 'VEHICLE_AREA' }
                                            }}
                                            onMenuOpen={() => ConstantService.getConstantList('VEHICLE_AREA')}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Tüketilen Yakıt (%)</label>
                                        <CustomNumberInput value={fuelConsumed} setValue={setFuelConsumed} />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Yakıt Kapasitesi (LT)</label>
                                        <CustomNumberInput value={fuelCapacity} setValue={setFuelCapacity} />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="vehicle-hgs-etiket-no" className="form-label">HGS Etiket No</label>
                                        <input id="vehicle-hgs-etiket-no" style={{ border: '1px solid #F1F1F4' }} value={hgsEtiketNo ?? ''} onChange={(e) => setHgsEtiketNo(e.target.value)} type="text" maxLength={50} className="form-control form-control-solid" />
                                    </div>
                                </div>
                            </div>

                            <div className="row mt-5">
                                <div className="col-md-12">
                                    <div>
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Araç Özellikleri</label>

                                        <CustomMultiSelect
                                            selectedValues={selectedVehicleProperties}
                                            onChange={setSelectedVehicleProperties}
                                            insertable={{
                                                onSubmit: { code: 'VEHICLE_PROPERTY' }
                                            }}
                                            onMenuOpen={() => ConstantService.getConstantList('VEHICLE_PROPERTY')}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Bloke</label>

                                        <Box flexDirection='row'>
                                            <Box width='80px'>
                                                <CustomSwitch
                                                    isActive={isBlocked}
                                                    setIsActive={() => {
                                                        var newVal = !isBlocked;

                                                        if (!newVal)
                                                            setBlockedDesc('');

                                                        setIsBlocked(newVal);
                                                    }}
                                                />
                                            </Box>
                                            <Box ml='15px' flexGrow={1}>
                                                <CustomTextInput placeholder={isBlocked ? 'Bloke Açıklaması' : undefined} isDisabled={!isBlocked} value={blockedDesc} setValue={setBlockedDesc} />
                                            </Box>
                                        </Box>
                                    </div>

                                    <div className="mt-5">
                                        <div>
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Aktif</label>
                                            <CustomSwitch isActive={isCustomActive} setIsActive={setIsCustomActive} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <label htmlFor="exampleFormControlInput1" className="form-label">Araç Resmi</label>

                            <div>
                                <img onClick={() => dispatch(storeImageViewer([b64]))} style={{ width: '100%' }} className="actionIcon img img-thumbnail" src={b64} />

                                <div className='mt-5 p-3 img img-thumbnail d-flex'>
                                    <div className='d-flex flex-grow-1'>
                                        <input accept="image/*" ref={fileRef} onChange={(e) => { setFile(e && e.target && e.target.files && e.target.files.length > 0 ? e.target.files[0] : undefined); handleFileRead(e, setB64); }} type="file" className="form-control form-control-solid" />
                                    </div>

                                    {
                                        !Helpers.isEmpty(b64) && (
                                            <div style={{ marginLeft: 15 }} className='d-flex align-items-center'>
                                                <i onClick={() => { setFile(undefined); setB64(Helpers.getPlaceholder()); fileRef.current.value = ""; }} style={{ fontSize: 18 }} className='actionIcon text-danger fa fa-trash' />
                                            </div>
                                        )
                                    }
                                </div>

                                <div className='mt-5 p-3 img img-thumbnail d-flex'>
                                    <CustomTextInput placeholder='Ara...' value={imageSearch} setValue={setImageSearch} />
                                </div>

                                <div className="row mt-5">
                                    {
                                        vehicleTypeList2.filter(x => imageSearch && !Helpers.isEmpty(imageSearch) ? x.value.toLowerCase().includes(imageSearch.toLowerCase()) : true).map((item, index) =>
                                            <div className={(index > 2 ? 'mt-5' : '') + ' col-md-4'}>
                                                <img
                                                    style={{ border: b64 == item.additionalValue2 ? '1px solid #1B84FF' : undefined }}
                                                    onClick={() => {
                                                        if (b64 == item.additionalValue2) {
                                                            setB64(Helpers.getPlaceholder());

                                                        }
                                                        else {
                                                            setB64(item.additionalValue2 ?? Helpers.getPlaceholder());
                                                        }

                                                        setFile(undefined);

                                                        if (fileRef && fileRef.current)
                                                            fileRef.current.value = "";
                                                    }}
                                                    className='img img-thumbnail'
                                                    src={item.additionalValue2}
                                                />

                                                <Box alignItems='center' mt='5px'>
                                                    <label style={{ marginLeft: 0 }} className="form-check-label">
                                                        {item.value}
                                                    </label>
                                                </Box>

                                                {/* <div className="mt-3 form-check form-check-custom form-check-solid d-flex justify-content-center">
                                                    <input onChange={(e) => setB64(b64 == item.vehicleTypeImage ? '' : item.vehicleTypeImage)} className="form-check-input" type="checkbox" value="" id={"flexCheckDefault-" + item.vehicleTypeId} checked={b64 == item.vehicleTypeImage} />
                                                    <label style={{ marginLeft: 5 }} className="form-check-label ml-0" htmlFor={"flexCheckDefault-" + item.vehicleTypeId}>
                                                        {item.vehicleTypeName}
                                                    </label>
                                                </div> */}
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default GeneralInformation;